import { render, staticRenderFns } from "./StaffAdminSubPage.vue?vue&type=template&id=31889461"
import script from "./StaffAdminSubPage.vue?vue&type=script&lang=js"
export * from "./StaffAdminSubPage.vue?vue&type=script&lang=js"
import style0 from "./StaffAdminSubPage.vue?vue&type=style&index=0&id=31889461&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports